module.exports = __webpack_public_path__ + "static/img/multiple-signs.9be6feb.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/multiple-signs.png
// module id = vRQz
// module chunks = 1